module.exports = __webpack_public_path__ + "static/media/GothamSSm-Book.ddf04395.otf";